//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "GRACE",
  data() {
    return {
      disabled: false,
      hasScore: false,
      descTxt: '',
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        age: '',
        heartRate: '',
        systolic: '',
        blood: '',
        killip: ''
      },
      defaultJson: {
        "ageTitle": "年龄(岁)",
        "heartRateTitle": "心率(次/分)",
        "systolicTitle": "收缩压(mmHg)",
        "bloodTitle": "血肌酐(mg/dL)",
        "killipTitle": "killip分级",
      },
      ageList: [
        { value: "0", name: "<30", },
        { value: "8", name: "30~39", },
        { value: "25", name: "40~49", },
        { value: "41", name: "50~59", },
        { value: "58", name: "60~69", },
        { value: "75", name: "70~79", },
        { value: "91", name: "80~89", },
        { value: "100", name: "≥90", },

      ],
      heartRateList: [
        { value: "0", name: "<50", },
        { value: "3", name: "50~69", },
        { value: "9", name: "70~89", },
        { value: "15", name: "90~109", },
        { value: "24", name: "110~149", },
        { value: "38", name: "150~199", },
        { value: "46", name: "≥200", },
      ],
      systolicList: [
        { value: "58", name: "<80", },
        { value: "53", name: "80~99", },
        { value: "43", name: "100~119", },
        { value: "34", name: "120~139", },
        { value: "24", name: "140~159", },
        { value: "10", name: "160~199", },
        { value: "0", name: "≥200", },
      ],
      bloodList: [
        { value: "1", name: "0~0.39", },
        { value: "4", name: "0.4~0.79", },
        { value: "7", name: "0.8~1.19", },
        { value: "10", name: "1.2~1.59", },
        { value: "13", name: "1.6~1.99", },
        { value: "21", name: "2~3.99", },
        { value: "28", name: "≥4.0", },
      ],
      killipList: [
        { value: "0", name: "无心衰的临床表现", shortName: "Ⅰ " },
        { value: "20", name: "肺部听诊啰音，可及第三心音(S3)，颈静脉压力升高", shortName: "Ⅱ" },
        { value: "39", name: "Frank急性肺水肿", shortName: "Ⅲ" },
        { value: "59", name: "心源性休克或低血压(收缩压<90mmHg)，同时存在周围血管收缩的证据(少尿，紫绀，发汗等)", shortName: "Ⅳ" },
      ],

    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (form.item1 == 1) {
        form.item1 = 39
      }
      if (form.item2 == 1) {
        form.item2 = 28
      }
      if (form.item3 == 1) {
        form.item3 = 14
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result =
          form.item1 +
          form.item2 +
          form.item3 +
          form.age +
          form.heartRate +
          form.systolic +
          form.blood +
          form.killip;
        console.log(result);
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/GRACE.vue